import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'core-ui-loader-base',
    templateUrl: './loader-base.component.html',
    styleUrls: ['./loader-base.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderBaseComponent {
    @Input() sizePx: number = 79.49;

    @Input() withPadding: boolean = true;

    @Input() gapPx: number = 12;

    @Input() dotLeftPercent: number = 47.37;
    @Input() dotRotateDeg: number = 212;

    @Input() dotSizePx: number = 8.7;

    @Input() dotTranslateRatio: number = 33.7 / 79.49;

    get dotTranslatePx(): number {
        return this.sizePx * this.dotTranslateRatio;
    }
}